export const PROFILE_CONSTANTS = {
  // Array fields that should always be arrays of strings or objects
  ARRAY_FIELDS: [
    'skills', 'languages', 'certifications', 'soft_skills', 
    'work_samples', 'preferred_project_types', 'other_profiles',
    'work_experience', 'portfolio_links', 'industry_specialization', 'security_questions'
  ],
  
  // JSON fields that are stored as JSONB in the database
  JSON_FIELDS: [
    'skills', 'availability', 'portfolio_links', 'certifications', 
    'languages', 'soft_skills', 'work_samples', 'assessment_scores',
    'other_profiles', 'preferred_project_types', 'work_experience',
    'industry_specialization'
  ],

  // Required fields for form validation
  REQUIRED_FIELDS: [
    'full_name', 'email', 'title', 'bio', 'location', 
    'hourly_rate', 'experience_years', 'availability_status'
  ],
  
  // URL fields that need validation
  URL_FIELDS: [
    'website', 'linkedin', 'portfolio_url', 'github_url', 'video_introduction_url'
  ],
  
  // Numeric fields that need proper parsing
  NUMERIC_FIELDS: [
    'hourly_rate', 'minimum_rate', 'maximum_rate'
  ],
  
  // Integer fields
  INTEGER_FIELDS: [
    'experience_years'
  ],

  // Skill categories with suggested skills
  SKILL_CATEGORIES: {
    'Administrative': [
      'Data Entry', 'Email Management', 'Calendar Management', 
      'Document Preparation', 'Travel Planning', 'Research', 'CRM Management'
    ],
    'Technical': [
      'Web Development', 'Graphic Design', 'Database Management', 
      'SEO/SEM', 'Analytics', 'WordPress', 'Automation', 'API Integration'
    ],
    'Creative': [
      'Content Writing', 'Copywriting', 'Social Media', 'Video Editing', 
      'Photography', 'Brand Design', 'Illustration', 'UI/UX Design'
    ],
    'Communication': [
      'Customer Service', 'Live Chat Support', 'Phone Support', 
      'Email Support', 'Community Management', 'Public Relations'
    ],
    'Marketing': [
      'Digital Marketing', 'Social Media Marketing', 'Email Marketing', 
      'Content Marketing', 'Lead Generation', 'Market Research', 'PPC Management'
    ],
    'Project Management': [
      'Task Management', 'Team Coordination', 'Timeline Planning', 
      'Budget Management', 'Quality Assurance', 'Agile/Scrum'
    ],
    'Data Analysis': [
      'Excel/Spreadsheets', 'Data Visualization', 'Report Generation', 
      'Statistical Analysis', 'Market Analysis', 'KPI Tracking'
    ],
    'Finance': [
      'Bookkeeping', 'Invoicing', 'Expense Tracking', 
      'Financial Reporting', 'Tax Preparation', 'Budget Planning'
    ]
  },

  // Soft skills options
  SOFT_SKILLS: [
    'Problem Solving', 'Time Management', 'Attention to Detail', 'Adaptability',
    'Critical Thinking', 'Leadership', 'Teamwork', 'Initiative', 'Reliability',
    'Multitasking', 'Organization', 'Communication', 'Creativity', 'Patience'
  ],

  // Industry specializations
  INDUSTRY_SPECIALIZATIONS: [
    'Healthcare', 'Real Estate', 'E-commerce', 'Education', 'Technology',
    'Finance', 'Legal', 'Marketing', 'Non-profit', 'Manufacturing',
    'Retail', 'Hospitality', 'Construction', 'Media', 'Government'
  ],

  // Project types
  PROJECT_TYPES: [
    'One-time Projects', 'Ongoing Support', 'Short-term (1-3 months)',
    'Long-term (6+ months)', 'Part-time', 'Full-time', 'Consulting', 'Training'
  ],

  // Dropdown options
  LANGUAGE_LEVELS: ['Basic', 'Conversational', 'Fluent', 'Native'],
  
  WORK_TYPES: ['remote', 'hybrid', 'on-site', 'flexible'],
  
  AVAILABILITY_STATUSES: ['available', 'busy', 'partially_available', 'unavailable'],
  
  EXPERIENCE_CATEGORIES: ['entry', 'intermediate', 'advanced', 'expert'],
  
  COMMUNICATION_STYLES: ['professional', 'casual', 'formal', 'friendly'],
  
  // Work Style Options
  WORK_PACE_PREFERENCES: ['fast_paced', 'balanced', 'methodical'],
  
  FEEDBACK_PREFERENCES: ['detailed', 'regular', 'minimal'],
  
  COLLABORATION_STYLES: ['independent', 'collaborative', 'adaptable'],
  
  PROBLEM_SOLVING_APPROACHES: ['analytical', 'creative', 'practical', 'innovative'],

  // Validation limits
  VALIDATION_LIMITS: {
    BIO_MAX_LENGTH: 1000,
    PORTFOLIO_DESCRIPTION_MAX_LENGTH: 500,
    PROFILE_PICTURE_MAX_SIZE: 5 * 1024 * 1024, // 5MB
    MIN_RATE: 0,
    MAX_EXPERIENCE_YEARS: 50
  },

  // Profile completion weights
  COMPLETION_WEIGHTS: {
    REQUIRED_WEIGHT: 0.7,
    OPTIONAL_WEIGHT: 0.3
  },

  // Optional fields for completion calculation
  OPTIONAL_FIELDS: [
    'phone', 'website', 'linkedin', 'certifications', 'education',
    'industry_specialization', 'portfolio_description',
    'portfolio_url', 'github_url', 'work_experience', 'work_pace',
    'feedback_preference', 'collaboration_style', 'problem_solving_approach',
    'work_style_description', 'experience_level', 'timezone', 'profile_picture',
    'video_introduction_url'
  ]
};
